import DeviceManager from '../utils/device-manager';

export function smoothScroll($element: HTMLElement, offset = false) : void {
    let yOffset = 0;
    const $stickyNavOffer = document.querySelector<HTMLElement>('.nav-offer-sticky');

    if ($stickyNavOffer && DeviceManager.isGreaterThanOrEqual(DeviceManager.getCurrentDevice(), 'md')) {
        yOffset = $stickyNavOffer.offsetHeight + $stickyNavOffer.offsetTop + 20;
    } else if (!DeviceManager.isGreaterThanOrEqual(DeviceManager.getCurrentDevice(), 'md')) {
        yOffset = 70;
    } else {
        yOffset = 100;
    }

    if ($element) {
        let y = 0;
        if (offset) {
            y = $element.offsetTop - yOffset;
        } else {
            y = $element.getBoundingClientRect().top + window.scrollY - yOffset;
        }

        window.scrollTo({
            top: y,
            behavior: 'smooth',
        });
    }
}

type SmoothScrollAnchorType = {
    desktopInitialized: boolean,
    $anchorLinks: HTMLElement[],
    init(): void,
};

const SmoothScrollAnchor: SmoothScrollAnchorType = {
    desktopInitialized: false,
    $anchorLinks: [],

    init() : void {
        this.$anchorLinks = Array.from(document.querySelectorAll<HTMLElement>('a[href^="#"]'));

        this.$anchorLinks.forEach($link => {
            if (($link.getAttribute('href') as string).length > 1) { // Prevent binding href="#"
                $link.addEventListener('click', function(event) {
                    event.preventDefault();

                    const $element = document.querySelector<HTMLElement>(this.getAttribute('href') as string);
                    if ($element) {
                        smoothScroll($element);
                    }
                });
            }
        });
    },

};

export default SmoothScrollAnchor;
